"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkPlace = void 0;
const Place_1 = require("./Place");
const Result_type_1 = require("../../types/Result.type");
const SurveyObjectUnserializer_1 = require("./SurveyObjectUnserializer");
/**
 * WorkPlace place class for person usual work locations
 * Represents the primary work location of a person
 * This is an alias of Place with custom validation display name
 */
class WorkPlace extends Place_1.Place {
    constructor(dirtyParams, surveyObjectsRegistry) {
        super(dirtyParams, surveyObjectsRegistry);
    }
    /**
     * Creates a WorkPlace object from sanitized parameters
     * @param {ExtendedPlaceAttributes | SerializedExtendedPlaceAttributes} params - Sanitized place parameters
     * @returns {WorkPlace} New WorkPlace instance
     */
    static unserialize(params, surveyObjectsRegistry) {
        const flattenedParams = SurveyObjectUnserializer_1.SurveyObjectUnserializer.flattenSerializedData(params);
        return new WorkPlace(flattenedParams, surveyObjectsRegistry);
    }
    /**
     * Factory that validates input and creates a WorkPlace object
     * @param {Object} dirtyParams - Raw input parameters to validate
     * @returns {Result<WorkPlace>} Either a valid WorkPlace object or validation errors
     */
    static create(dirtyParams, surveyObjectsRegistry) {
        const errors = Place_1.Place.validateParams(dirtyParams, 'WorkPlace');
        const workPlace = errors.length === 0
            ? new WorkPlace(dirtyParams, surveyObjectsRegistry)
            : undefined;
        if (errors.length > 0) {
            return (0, Result_type_1.createErrors)(errors);
        }
        return (0, Result_type_1.createOk)(workPlace);
    }
}
exports.WorkPlace = WorkPlace;
//# sourceMappingURL=WorkPlace.js.map